import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLoader } from 'hooks';
import useStyles from 'components/ui/Loader/style';

const Loader = () => {
  const classes = useStyles();
  const { showLoader } = useLoader();

  if (!showLoader) {
    return null;
  }

  return (
    <div className={classes.loaderWrapper}>
      <CircularProgress
        className={classes.progress}
        size={40}
        thickness={4}
        value={100}
      />
    </div>
  );
};

export default Loader;
